import { useState } from "react";
import Section from "../components/ui/Section";
import SkeletonVideo from "../components/skeleton/Skeleton";
import VideoModal from "../components/video/VideoModal";
import { useGetChannelVideosQuery } from "../features/api/youtubeApi";
import "./FeaturedAdventures.scss";

export default function FeaturedAdventures() {
  const [activeIndex, setActiveIndex] = useState(null);

  const { data, isLoading } = useGetChannelVideosQuery({
    page: 1,
    limit: 3,
    isShort: false,
  });

  const videos = data?.items || [];

  return (
    <>
      <Section
        title="Recent Journeys"
        subtitle="Recent long-form road stories from Mini Miles Adventures"
      >
        <div className="featured">
          <div className="featured__grid">
            {isLoading &&
              Array.from({ length: 3 }).map((_, i) => (
                <SkeletonVideo key={i} />
              ))}

            {videos.map((video, index) => (
              <button
                key={video._id}
                className="featured__card"
                onClick={() => setActiveIndex(index)}
              >
                <img
                  src={video.thumbnails?.high?.url}
                  alt={video.title}
                  loading="lazy"
                />

                <div className="featured__overlay" />

                <div className="featured__content">
                  <h3>{video.title}</h3>
                </div>
              </button>
            ))}
          </div>
        </div>
        {/* <button className="home-hero__cta">VIEW ALL</button> */}
      </Section>

      {activeIndex !== null && (
        <VideoModal
          videos={videos}
          currentIndex={activeIndex}
          onClose={() => setActiveIndex(null)}
        />
      )}
    </>
  );
}
